import { Translation } from '@ps/web-shared-components';
import React, { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';

import Table from '../../../../components/Table/Table';
import { PKR_LOADERS, PKR_USER_ROLE_TRANSLATIONS } from '../../../../constants';
import { useHomeGamesWidget } from '../../../../model';
import styles from '../shared.scss';
import { MemberStatusesPerPage, columnsNonMembers } from '../utils';

import ActionButtons from './ActionButtons';

const Blocked: React.FC = () => {
  const { clubId } = useParams<{ clubId: string }>();
  const { widgetSelect, widgetDispatch } = useHomeGamesWidget();
  const loadingState = useSelector(widgetSelect.loading);
  const { blocked } = useSelector(widgetSelect.clubMembers);
  const loading = loadingState[PKR_LOADERS.clubMembers];

  useEffect(() => {
    widgetDispatch.fetchClubMembers({
      clubId,
      statuses: MemberStatusesPerPage.Blocked,
      memberType: 'blocked'
    });

    return () => {
      widgetDispatch.setLoading({ isLoading: true, loaderName: PKR_LOADERS.clubInfo });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clubId]);

  const transformedMembers = useMemo(
    () =>
      blocked.map((member) => ({
        ...member,
        // eslint-disable-next-line react/jsx-no-useless-fragment
        enrolled: <></>,
        role: (
          <Translation
            {...PKR_USER_ROLE_TRANSLATIONS[
              member.memberRole as keyof typeof PKR_USER_ROLE_TRANSLATIONS
            ]}
          />
        )
      })),
    [blocked]
  );

  return (
    <div className={styles.blocked}>
      <Table
        columns={columnsNonMembers}
        data={transformedMembers}
        selectable
        sortable={false}
        searchBy="userId"
        actionButtons={ActionButtons}
        loading={loading}
        type="blocked"
      />
    </div>
  );
};

export default Blocked;
